/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Meeting_Title_LabelInputs */



/**
* | output |
* | --- |
* | "What is the conversation?" |
*
* @param {Manual_Meeting_Title_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const manual_meeting_title_label = /** @type {((inputs?: Manual_Meeting_Title_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Meeting_Title_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Welk gesprek is het?")
	if (locale === "fr") return /** @type {LocalizedString} */ ("De quelle conversation s’agit-il ?")
	return /** @type {LocalizedString} */ ("What is the conversation?")
});